var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.$t('common.state'),"items":_vm.list,"value":_vm.value,"single-line":"","hide-details":"","solo":"","light":"","flat":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }